import { all } from "redux-saga/effects";
import { createSessionSaga, startInPresetSessionSaga } from "./sagas/sessionSaga";
import {
    activateMaskItemSaga,
    activateItemSaga,
    activateMenuSaga,
    activateByArticleNumberSaga,
    setSurfacePattern,
    updateLayoutsSaga,
    changeSurfaceLayoutsSaga,
    setFavoriteSaga,
    reloadConfigurationSaga,
    watchLoadConfigSaga,
} from "./sagas/configurationSaga";
import { getConfigurationImageAndMaskSaga, loadMaskDataSaga } from "./sagas/imagesSaga";
import { loadMetadataSaga } from "./sagas/metadataSaga";
import { sideMenuActivateItemSaga, sideMenuSetItemsSaga } from "./sagas/sideMenuSaga";
import { updateFiltersFromMenuItemsSaga, resetItemFilterSaga, filterItemsSaga } from "./sagas/filterTypeSaga";
import { triggerTimeout } from "./sagas/timeoutSaga";
import { initGoogleAnalyticsSaga, updateGoogleAnalyticsModelIdSaga } from "./sagas/analyticsSaga";
import { initialiseSagaMiddleware } from "../store";
import { callToActionSaga, triggerExternalConfiguratorUpdateSaga } from "./sagas/externalSagas";
import { initGoogleTagManagerSaga } from "./sagas/googleTagManagerSaga";

function* rootSaga() {
    yield all([
        createSessionSaga(),
        startInPresetSessionSaga(),
        loadMetadataSaga(),
        getConfigurationImageAndMaskSaga(),
        loadMaskDataSaga(),
        activateMaskItemSaga(),
        activateMenuSaga(),
        activateItemSaga(),
        activateByArticleNumberSaga(),
        setSurfacePattern(),
        updateLayoutsSaga(),
        setFavoriteSaga(),
        changeSurfaceLayoutsSaga(),
        reloadConfigurationSaga(),
        watchLoadConfigSaga(),
        sideMenuActivateItemSaga(),
        sideMenuSetItemsSaga(),
        resetItemFilterSaga(),
        updateFiltersFromMenuItemsSaga(),
        filterItemsSaga(),
        initGoogleAnalyticsSaga(),
        initGoogleTagManagerSaga(),
        updateGoogleAnalyticsModelIdSaga(),
        callToActionSaga(),
        triggerExternalConfiguratorUpdateSaga(),
        triggerTimeout(),
    ]);
}

export function startRootSaga() {
    initialiseSagaMiddleware.run(rootSaga);
}
